

















































import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { SystemCode, SystemCodeWithKey } from '@/api'

@Component({
  components: {
    InputCode
  }
})
export default class InputCodeAndTextField extends ComponentVue {
  @Ref()
  inputCode!: InputCode

  @Prop({
    type: String,
    default: ''
  })
  codeValue!: string

  @Prop({
    type: String,
    default: ''
  })
  textValue!: string

  @Prop({
    type: String,
    required: true
  })
  codeKey!: string

  @Prop({
    type: Boolean,
    default: false
  })
  inputText!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  hyphen!: boolean

  @Prop({
    type: Number,
    default: 4
  })
  inputCodeCols!: number

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  autofocusCode!: boolean

  @Prop({
    type: String
  })
  mask!: string

  @Prop({
    type: Boolean
  })
  error!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  erase!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  erasable!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({
    type: Promise
  })
  defaultSystemCode!: Promise<SystemCodeWithKey>

  @Prop({
    type: Array,
    default: () => []
  })
  exclusionCodes!: string[]

  get isDisabledSystemCode(): boolean {
    return this.disabled || this.erase
  }

  @Emit('input:code')
  onInputCodeKey(): void {}

  @Emit('input:text')
  onInputText(): void {}

  @Emit('input:system-code')
  onInputSystemCode(
    item: SystemCode | SystemCode[] | null
  ): SystemCode | SystemCode[] | null {
    return item
  }

  @Emit('click:list')
  onClickCodeKeyList(): void {}

  @Emit('click:erase')
  onClickErase(): void {}

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
